import { useEffect, useRef } from 'react'
import './stylesheets/ErrorBox.scss'

export default function ErrorBoxComponent({ noty, closeNoty }) {
  const activeNotyRef = useRef(null)

  useEffect(() => {
    if (!noty) {
      activeNotyRef.current = null
      return undefined
    }

    if (activeNotyRef.current === noty) {
      return undefined
    }

    activeNotyRef.current = noty
    noty.on('onClose', () => {
      activeNotyRef.current = null
      closeNoty()
    })
    noty.show()

    return () => {
      if (activeNotyRef.current === noty) {
        activeNotyRef.current = null
      }
    }
  }, [noty, closeNoty])

  return null
}
